import { axiosAction } from '../../utils/axiosAction';
import { SHELF_UNITS_FETCH } from '../action-types/shelfUnits-types';

const ENDPOINT_FETCH = `${process.env.REACT_APP_ENDPOINT_SHELF_UNITS}`;

export const getEntities = () => async dispatch => {
  return axiosAction.get(`${ENDPOINT_FETCH}`, SHELF_UNITS_FETCH, dispatch);
};
